module.exports = __webpack_public_path__ + "img/greensuitman4.90827eb2.jpg";